module.exports = __webpack_public_path__ + "static/media/user3.db77db2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/user3.png
// module id = 250
// module chunks = 0